import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',

    '& .information-fill': {
      display: 'none'
    },
    '& .information': {
      display: 'block'
    },
    '&:hover': {
      '& .information-fill': {
        display: 'block'
      },
      '& .information': {
        display: 'none'
      }
    }
  }
}))

export default useStyles
